/**
 * Created by SG0949773 on 10/23/2015.
 */
'use strict';

var ConfigurationEntityTransformerFactory = function ConfigurationEntityTransformerFactory($rootScope, DataTransformer) {
  function ConfigurationEntityTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-entity-mode';
    this.priority = 1;
  }
  ConfigurationEntityTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationEntityTransformer.constructor = ConfigurationEntityTransformer;
  ConfigurationEntityTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationEntityTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationEntityTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationEntityTransformer.prototype.transform = function (data) {
    $rootScope.$broadcast('configuration-entity:loadedSuccessful', data);
    return data.domain.entities;
  };
  return ConfigurationEntityTransformer;
};
ConfigurationEntityTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory'];
module.exports = ConfigurationEntityTransformerFactory;